import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import zh from './locales/zh.json';
import de from './locales/de.json';

const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('stockaris_lang') : null;

// Languages that render right-to-left. When the current language is in this
// set the `<html>` element gets `dir="rtl"` so Tailwind's `rtl:` utilities
// and default browser bidi handling flip the layout automatically.
export const RTL_LANGUAGES = new Set(['ar']);

function applyDirection(code) {
  if (typeof document === 'undefined') return;
  const dir = RTL_LANGUAGES.has(code) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', code);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      ar: { translation: ar },
      zh: { translation: zh },
      de: { translation: de },
    },
    lng: savedLang || 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

// Apply direction on initial load AND on every language change so RTL is
// picked up whether the user has 'ar' persisted from a previous visit or
// switches mid-session via the LanguageSwitcher dropdown.
applyDirection(i18n.language);
i18n.on('languageChanged', applyDirection);

export const supportedLanguages = [
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'es', label: 'Español', flag: 'ES' },
  { code: 'fr', label: 'Français', flag: 'FR' },
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'zh', label: '中文', flag: 'ZH' },
  { code: 'ar', label: 'العربية', flag: 'AR' },
];

export default i18n;
